module.exports = "/_next/static/images/ic-default-avatar-600fbcd59d23135d1d66c171476163b5.png";